import styled from "styled-components";
import {OptInWinHighlightAmountDefaultBox} from "./opt-in-win-highlight-amount.default.box";

export const OptInWinHighlightAmountCasino777Box = styled(OptInWinHighlightAmountDefaultBox)`

`;
